import $ from 'jquery'

$(function() {
  $(document).on('change', '.custom-file-input', function() {
    const label = $(this).siblings('.custom-file-label')
    const names = Array.from(this.files || []).map(file => file.name)

    label.text(names.length ? names.join(', ') : label.data('placeholder'))
  })
})
